import React from "react";
import { LANDING } from "../../constants/testIds";
import TypeformButton from "./TypeformButton";

// Sezione di chiusura: sostituisce il vecchio form multi-step: la candidatura si
// compila su Typeform, che si apre in popup sopra questa pagina.
export default function ApplicationCTA() {
  return (
    <section
      id="candidati"
      className="py-24 md:py-32 bg-cream font-sans"
      data-testid={LANDING.applicationCtaSection}
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="bg-bordeaux border border-champagne/20 p-8 md:p-12 space-y-8 relative text-center">

          {/* Decorative accent top line */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-champagne" />

          <div className="space-y-3">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-champagne">
              IL PRIMO PASSO VERSO TE STESSA
            </span>
            <h2 className="text-2xl sm:text-3xl font-normal font-editorial text-ivory">
              Candida la tua storia
            </h2>
            <p className="text-xs sm:text-sm text-ivory/70 max-w-lg mx-auto font-light">
              {"La candidatura non è vincolante né costituisce un acquisto. È un'opportunità esclusiva per capire se il metodo Feminine Return™ è adatto a te."}
            </p>
          </div>

          <TypeformButton
            className="bg-champagne-light text-chocolate hover:bg-champagne text-sm font-semibold tracking-widest px-8 py-5 rounded-none transition-luxury inline-block"
            testId={LANDING.ctaApplyForm}
          >
            COMPILA LA CANDIDATURA
          </TypeformButton>

          <p className="text-[11px] text-ivory/50 font-light">
            {"Bastano pochi minuti. Le tue risposte arrivano direttamente a Giulia, in totale riservatezza."}
          </p>

        </div>
      </div>
    </section>
  );
}
